module.exports = __webpack_public_path__ + "static/media/AAVE-USDT.15c81de5.svg";